module.exports = __webpack_public_path__ + "img/2.a2ac951e.jpg";